if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareButtonFallback: this.querySelector('.share-button__fallback'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          successIcon: this.querySelector('.share-button__icon-success'),
          urlInput: this.querySelector('input'),
          copyButton: this.querySelector('.share-button__copy'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.elements.shareButtonFallback.classList.add('hidden');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.copyButton.classList.add('hidden');
          this.elements.successIcon.classList.remove('hidden');
        });

        setTimeout(() => {
          this.resetToDefault();
        }, 2000);
      }

      resetToDefault() {
        this.elements.successIcon.classList.add('hidden');
        this.elements.copyButton.classList.remove('hidden');
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
